// src/components/ui/Card.js
import React from 'react';

export const Card = ({ children, style = {} }) => (
  <div
    style={{
      border: '1px solid #eee',
      borderRadius: '12px',
      backgroundColor: '#fff',
      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
      ...style
    }}
  >
    {children}
  </div>
);

export const CardContent = ({ children, style = {} }) => (
  <div style={{ padding: '1.5rem', ...style }}>
    {children}
  </div>
);